import Vue from 'vue'
import VueRouter from 'vue-router'
import ThreadList from './ThreadList.vue'

Vue.use(VueRouter)

export const boards = [
    {
        path: '/all/:page?',
        name: '0',
        component: ThreadList,
        meta: {
            tab: '全部'
        },
    },
    {
        path: '/star/:page?',
        name: '1',
        component: ThreadList,
        meta: {
            tab: '精品'
        },
    },
];

const routes = [
    {
        path: '/',
        redirect: '/all',
    },
    ...boards,
];

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    if (to.name) { // 首次进入不处理
        if (!to.params.page) to.params.page = 1;
    }
    next();
})

export default router
